import { render, staticRenderFns } from "./subjects-of-allegation-worker.vue?vue&type=template&id=48673156&scoped=true"
import script from "./subjects-of-allegation-worker.vue?vue&type=script&lang=js"
export * from "./subjects-of-allegation-worker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48673156",
  null
  
)

export default component.exports